import { forwardRef } from 'react';

import { dpr } from 'Utils/dpr';
import { getAspectRatioStyles } from 'Utils/getAspectRatioStyles';

import { ISrcSetSize } from 'Types/shared';
import Loader from 'Components/Loader';
import SourceSetPictureSource from 'Components/SourceSetPictureSource';
import { ISlideModel } from './ProductGalleryContainer';

interface IProductImageProps {
    data?: ISlideModel;
    isPlaceholder?: boolean;
    className?: string;
    index?: number;
    srcSetSizes: ISrcSetSize;
    hasZoomedIn?: boolean;
}

const ProductImageSlide = forwardRef<HTMLImageElement, IProductImageProps>(
    (
        {
            data,
            index,
            srcSetSizes,
            className = '',
            isPlaceholder,
            hasZoomedIn,
        }: IProductImageProps,
        ref
    ) => {
        if (data === undefined && isPlaceholder !== true) return null;

        return (
            <figure className="h-full w-full ">
                <picture className="swiper-zoom-container lg:!transform-none">
                    <SourceSetPictureSource
                        srcSetSizes={srcSetSizes}
                        src={data?.src}
                    />
                    <img
                        style={getAspectRatioStyles(srcSetSizes)}
                        className={` h-full w-full object-cover -:aspect-[var(--aspect-ratio-default)] -:h-full -:w-full -:object-cover -:transition-[visibility] -:md:aspect-[var(--aspect-ratio-md)] lg:!transform-none -:lg:aspect-[var(--aspect-ratio-lg)] -:xl:aspect-[var(--aspect-ratio-xl)] -:xxl:aspect-[var(--aspect-ratio-xxl)] ${
                            isPlaceholder ? ' -:invisible' : ' -:visible'
                        } ${className}`}
                        src={
                            isPlaceholder
                                ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjmLxn8X8ABsoC8muPGUAAAAAASUVORK5CYII='
                                : `${data.src}?format=webp&fit=crop&height=${srcSetSizes.default.height}&width=${srcSetSizes.default.width}`
                        }
                        srcSet={
                            isPlaceholder
                                ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjmLxn8X8ABsoC8muPGUAAAAAASUVORK5CYII='
                                : dpr(
                                      `${data.src}?format=webp&fit=crop&height=${srcSetSizes.default.height}&width=${srcSetSizes.default.width}`,
                                      hasZoomedIn
                                  )
                        }
                        alt={data?.altText}
                        width={srcSetSizes.default.width}
                        height={srcSetSizes.default.height}
                        loading={index !== 0 ? 'lazy' : 'eager'}
                        ref={ref}
                    />
                </picture>
                {index !== 0 && (
                    <div className="custom-preloader absolute left-0 top-0 h-full w-full">
                        <Loader size="32px" marginY="0" bgColor="bg-merino" />
                    </div>
                )}
            </figure>
        );
    }
);

export default ProductImageSlide;
